import React, { createContext, useContext } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import config from "@/config";

/**
 * Load Google Maps exactly once for the whole app.
 * Calling useJsApiLoader / useLoadScript from multiple places with different
 * options throws: "Loader must not be called again with different options".
 */
export const GOOGLE_MAPS_LOADER_ID = "google-map-script";

/** Stable array reference — never recreate at call sites. */
export const GOOGLE_MAPS_LIBRARIES = ["places"];

/** Stable options object for the single app-wide loader. */
export const GOOGLE_MAPS_LOADER_OPTIONS = {
  id: GOOGLE_MAPS_LOADER_ID,
  googleMapsApiKey: config.googleMapsApiKey,
  libraries: GOOGLE_MAPS_LIBRARIES,
  language: "en",
  region: "US",
};

const GoogleMapsContext = createContext({
  isLoaded: false,
  loadError: undefined,
});

export function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader(GOOGLE_MAPS_LOADER_OPTIONS);
  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

/** Read shared Google Maps load state — do not call useJsApiLoader elsewhere. */
export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}

/** @deprecated Use useGoogleMaps() instead of calling loaders directly. */
export function getGoogleMapsLoaderOptions() {
  return GOOGLE_MAPS_LOADER_OPTIONS;
}
